document.addEventListener('turbolinks:load', () => {
  $('.datepicker').datepicker();
})
